import React from 'react';
import { useState, useEffect } from 'react';
import Nav from './Nav';
import Footer from './Footer';
// import { BsBrowserEdge } from "react-icons/bs";
import { CiAlarmOn } from "react-icons/ci";
import { VscPass } from "react-icons/vsc";
import useFetch from '../Components/UseFetch';
import Orderpng from '../images/logo/Order3.png';
import Orderpng4 from '../images/logo/order4.png';
import UsePostWithReturns from '../Components/UsePostWithReturns.jsx';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import verifyToken from '../HelperFx/verifyJwt.js';
import './home.css';
import { addCommas } from '../HelperFx/common.js';
import { Link } from 'react-router-dom';
import { Buffer } from 'buffer';
import { ClipLoader, BeatLoader, CircleLoader } from 'react-spinners';
import Swal from 'sweetalert2';
import {customers, quotesAndOrders, getCustomerOrders, postedSalesCreditmemo, bankLedgerEntries, getTotalReversals,getCustomerpayments, getPostedInvoices,getPostedShipments, draftQuotes} from '../HelperFx/datalinks';


const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
  // //Console.log(username);
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;

const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const REACT_ACTION_URL = process.env.REACT_APP_ACTION_PI_DATA_URL;

const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;

//Console.log(REACT_APP_COMPANY_URL);

const eq = ' eq ';
const filter = '&$filter =';

const parseToObject = (input) =>{
  const output = {};
  const parts = input.split('$');
  parts.forEach(part => {
      const [key, value] = part.split(':');
      output[key] = value; // Convert numeric values
  });
  return output;
}

const LoaderExample = () => {
  return (
    <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', marginTop: '50px' }}>
      {/* <ClipLoader color="#36d7b7" size={50} /> */}
       <BeatLoader color="#36d7b7" size={15} />
      {/*<CircleLoader color="#36d7b7" size={100} /> */}
    </div>
  );
};


const Index = () => {

  const navigate = useNavigate();
  const [quoteDetails, setquoteDetails] = useState({});
  const [orderDetails, setorderDetails] = useState({});
  const [invoiceDetails, setinvoiceDetails] = useState({});
  const [shipmentDetails, setshipmentDetails] = useState({});
  const [pmtDetails, setPaymentsDetails] = useState({});
  const [revDetails, setReversalsDetails] = useState({});
  // Additions
  const [jwttoken, setAuthToken] = useState(sessionStorage.getItem('authToken'));
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, 'utf8').toString('base64');
  // const token = Buffer.from(`HRP:HRPbc@2023`, 'utf8').toString('base64');
  // const jwttoken = localStorage.getItem('authToken');
  
  // const {custName, userName, password} = jwttoken ? verifyToken(jwttoken) : {custName: '', userName: '', password: ''};
  //Console.log(verifyToken(jwttoken));
  const {custName, userName, password} = (jwttoken && verifyToken(jwttoken)) || {};
  //Console.log(custName, userName, password);

  // if (!custName || !userName || !password){
  // if (!custName || !userName){
  //   navigate('/signin');
  // } 
  useEffect(() => {
    if (!custName || !userName) {
      navigate('/signin');
    }
  }, [custName, userName, navigate]);

  

  // Get customer quotes details
  const quotesuri = `${REACT_ACTION_URL}${quotesAndOrders}?${REACT_APP_COMPANY_URL}`;
  const orderurl = `${REACT_ACTION_URL}${getCustomerOrders}?${REACT_APP_COMPANY_URL}`;
  const invoiceurl = `${REACT_ACTION_URL}${getPostedInvoices}?${REACT_APP_COMPANY_URL}`;
  const paymentsurl = `${REACT_ACTION_URL}${getCustomerpayments}?${REACT_APP_COMPANY_URL}`;
  const reversalsurl = `${REACT_ACTION_URL}${getTotalReversals}?${REACT_APP_COMPANY_URL}`;
  const postedShipmentsurl = `${REACT_ACTION_URL}${getPostedShipments}?${REACT_APP_COMPANY_URL}`;
  // const quoteid = {"cust":custName};
  const memoizedQuoteUrl = useMemo(() => quotesuri, [quotesuri]);
  const memoizedOrderUrl = useMemo(() => orderurl, [orderurl]);
  const memoizedInvoiceUrl = useMemo(() => invoiceurl, [invoiceurl]);
  const memoizedShipmentUrl = useMemo(() => postedShipmentsurl, [postedShipmentsurl]);
  const memoizedPaymentsUrl = useMemo(() => paymentsurl, [paymentsurl]);
  const memoizedReversalsUrl = useMemo(() => reversalsurl, [reversalsurl]);
  const memoizedToken = useMemo(() => token, [token]);
  const memoizedPostData = useMemo(() => ({"cust":custName}), [custName]);

  const {data: quotes, quotesloading, quoteserror} = UsePostWithReturns(memoizedQuoteUrl,memoizedToken,memoizedPostData);
  const {data: invoices, invoiceloading, invoiceerror} = UsePostWithReturns(memoizedInvoiceUrl,memoizedToken,memoizedPostData);
  const {data: shipments, shipmentloading, shipmenterror} = UsePostWithReturns(memoizedShipmentUrl,memoizedToken,memoizedPostData);
  const {data: orders, ordersloading, orderserror} = UsePostWithReturns(memoizedOrderUrl,memoizedToken,memoizedPostData);
  const {data: payments, pmtloading, pmtloaderrors} = UsePostWithReturns(memoizedPaymentsUrl,memoizedToken,memoizedPostData);
  const {data: reversals, reversalsloading, reversalserror} = UsePostWithReturns(memoizedReversalsUrl,memoizedToken,memoizedPostData);
  //Console.log(quotes)
  //Console.log('Now here');

  useEffect(() => {
    if (quotes && quotes.value) {
      const obj = parseToObject(quotes.value);
      setquoteDetails(obj);
    }
  }, [quotes]);

  useEffect(() => {
    if (orders && orders.value) {
      const obj = parseToObject(orders.value);  
      setorderDetails(obj);
    }
  }, [orders]);

  useEffect(() => {
    if (invoices && invoices.value) {
      const obj = parseToObject(invoices.value);  
      setinvoiceDetails(obj);
    }
  }, [invoices]);

  useEffect(() => {
    if (payments && payments.value) {
      const obj = parseToObject(payments.value);
      setPaymentsDetails(obj);
    }
  }, [payments]);

  useEffect(() => {
    if (reversals && reversals.value) {
      const obj = parseToObject(reversals.value);
      setReversalsDetails(obj);
    }
  }, [reversals]);
  useEffect(() => {
    if (shipments && shipments.value) {
      const obj = parseToObject(shipments.value);
      setshipmentDetails(obj);
    }
  }, [shipments]);

  const createDraftQuoteAndNavigateToDraft = async () => {
    const headerResponse = await fetch(`${REACT_DATA_URL}${draftQuotes}?${REACT_APP_COMPANY_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Basic ${token}`
      },
      body: JSON.stringify({
        "sellToCustomerNo":custName,
        portalUser: userName,
        documentType:"Quote"
      })
    });

    if (!headerResponse.ok) {
          Swal.fire({
          icon: '',
          title: 'Oops...',
          text: headerResponse.statusText,
          showConfirmButton: true,
          customClass: {
            popup: 'small-swal-popup',
            icon: 'hide-swal-icon'
          }
          });
        }
    
    if(headerResponse.ok){
      const headerResult = await headerResponse.json();
      navigate(`/DraftOrder`, {state: {createdNumber: headerResult.no, documentType: headerResult.documentType, systemId: headerResult.systemId}})
    }
  }

  const { data: customer, loading, error } = useFetch(`${REACT_DATA_URL}${customers}?${REACT_APP_COMPANY_URL}${filter}no${eq}'${custName}'`, token);

  const { data: salesCreditMemo, loadingCreditMemo, errorCreditMemo } = useFetch(`${REACT_DATA_URL}${postedSalesCreditmemo}?${REACT_APP_COMPANY_URL}${filter}customerNo${eq}'${custName}'&$top=1`, token);
  const { data: salesBankLedgerEntries, loadingBankLedgerEntries, errorBankLedgerEntries } = useFetch(`${REACT_DATA_URL}${bankLedgerEntries}?${REACT_APP_COMPANY_URL}${filter}balAccNo${eq}'${custName}'&$top=1`, token);
  const initialCreditMemo = salesCreditMemo?.value[0]
  const initialBankLedgerEntry = salesBankLedgerEntries?.value[0]
  //Console.log('Started Processing Bank Ledgers:')
  //Console.log(initialBankLedgerEntry)

  useEffect(() => {
    const handleStorageChange = () => {
      setAuthToken(sessionStorage.getItem('authToken'));
      window.location.reload();
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const CustomerInformation = customer?.value[0];
  //Console.log(CustomerInformation);
  //Console.log(`${REACT_DATA_URL}${customers}?${REACT_APP_COMPANY_URL}&${filter}no${eq}'${custName}'`)
  //Console.log(`customer information: ${CustomerInformation}`);

  if (loading) return <div><LoaderExample/></div>;
  if (error) return <div>Error loading customer data: {error.message}</div>;

  return (
    <div className="Home">

      <Nav/>
      <div className="dash-main">
        <div className="customer">
          <span className="fs-5 cust-details">Details</span>

            {
              CustomerInformation ? (
            <div className="cust-overview">

                <div className="cust-col-detail">
                  <div className="field-name">Name:</div>
                  <div className="field-value">{CustomerInformation.name}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name">Customer Number:</div>
                  <div className="field-value">{CustomerInformation.no}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name">TIN Number</div>
                  <div className="field-value">{CustomerInformation.vatRegistrationNo}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name">Balance Due</div>
                  <div className="field-value">{addCommas(CustomerInformation.balanceLCY)}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name">Credit Limit</div>
                  <div className="field-value">{addCommas(CustomerInformation.creditLimit)}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name">Phone No.</div>
                  <div className="field-value">+{CustomerInformation.phoneNo}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name">Address 1</div>
                  <div className="field-value">{CustomerInformation.Adress}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name">Email Address</div>
                  <div className="field-value">{CustomerInformation.eMail}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name">Payment Terms</div>
                  <div className="field-value">{CustomerInformation.paymentTermsCode}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name ">Prepayment %</div>
                  <div className="field-value">{CustomerInformation.Balance_LCY}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name ">Currency</div>
                  <div className="field-value">{CustomerInformation.currencyCode ? CustomerInformation.currencyCode : 'UGX'}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name ">Tax Group</div>
                  <div className="field-value">{CustomerInformation.vatBusPostingGroup}</div>
                </div>
                <div className="cust-col-detail">
                  <div className="field-name ">Ship To</div>
                  <div className="field-value">{CustomerInformation.shipTo}</div>
                </div>
            </div>) : (<div className="cust-overview">Loading..</div>)
              
            }
        </div>
          
        <div className="data-tiles">
          <div className="documents">
            <Link className="doc" to="/PurchaseQuotes">
              <div className="head">
                <CiAlarmOn size={25} style={{background:"#28231D",padding:"3px",borderRadius:"50%", color:"white"}}/>
                <span>Quotes ({quoteDetails?.Count || 0})</span>
              </div>
              <div className="wording">
                <div className="total">
                  <span style={{padding:"5px"}}>Worthy: Shs.<b>{quoteDetails?.Amount|| 0}</b></span>
                  {/* <FaSalesforce size={40} color="green" /> */}
                </div>
              </div> 
            </Link>
            <Link className="doc" to="/PurchaseOrders">
              <div className="head">
                {/* <CiAlarmOn size={25} style={{background:"#28231D",padding:"3px",borderRadius:"50%", color:"white"}}/> */}
                <span>Pending Orders ({orderDetails?.Count || 0})</span>
              </div>
              <div className="wording">
                <div className="total">
                  <span style={{padding:"5px"}}>Worthy: Shs.<b>{orderDetails?.Amount|| 0}</b></span>
                
                  {/* <FaSalesforce size={40} color="green" /> */}
                </div>
              </div> 
            </Link>
            <Link className="doc" to="/PostedPurchaseInvoices">
              <div className="head">
              <VscPass size={25} style={{background:"#28231D",padding:"3px",borderRadius:"50%", color:"white"}}/>
              <span>Order History ({invoiceDetails?.Count|| 0})</span>
              </div>
              <div className="wording">
                <div className="total">
                  <span style={{padding:"5px"}}>Worthy: Shs.<b>{invoiceDetails?.Amount|| 0}</b></span>
                  {/* <FaSalesforce size={40} color="green" /> */}
                </div>
              </div> 
            </Link>

            <Link className="doc" to="/Receipts">
              <div className="head">
                <VscPass size={25} style={{background:"#28231D",padding:"3px",borderRadius:"50%", color:"white"}}/>
                <span>Shipped orders ({shipmentDetails?.Count|| 0})</span>
              </div>
              <div className="wording">
                <div className="total">
                  <span style={{padding:"5px"}}>Purchase Receipts</span>
                  {/* <FaSalesforce size={40} color="green" /> */}
                </div>
              </div> 
            </Link>
          </div>
          <div className="payrec">
            <div className="pay-1">
              <span class="pay-1-span">
                <span>Reversals (Credit Memos)</span>
                <Link to='/PurchaseCreditMemos'>Show more</Link>
              </span>
              <table className="home-table">
                <thead>
                  <tr>
                    <th>Document No.</th>
                    <th>Currency</th>
                    <th>Amount.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{initialCreditMemo?.number}</td>
                    <td>{initialCreditMemo?.currencyCode}</td>
                    <td>{addCommas(initialCreditMemo?.amount)}</td>
                  </tr>
                </tbody>
              </table>
              <span>Total Reversals: UGX.{addCommas(revDetails?.Amount|| 0)}/=</span>
            </div>
            <div className="pay-1">
              <span class="pay-1-span">
                <span>Payments</span>
                <Link to='/Payments'>Show more</Link>
              </span>
              <table className="home-table">
                <thead>
                  <tr>
                    <th>Document No.</th>
                    <th>Description</th>
                    <th>Amount.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{initialBankLedgerEntry?.documentNo}</td>
                    <td>{initialBankLedgerEntry?.description}</td>
                    <td>{addCommas(initialBankLedgerEntry?.amount)}</td>
                  </tr>
                </tbody>
              </table>
              <span>Total Payments: UGX.{pmtDetails?.Amount|| 0}/=</span>
            </div>
           
          </div>
          <div className="trending">
            <span class="z-span px-2"
            style={{
              backgroundImage: `repeating-linear-gradient(
                to bottom,
                rgba(131, 186, 79, 0.3),
                rgba(236, 142, 95, 0.3) 5px,
                rgba(255, 255, 255, 0.3) 5px,
                rgba(255, 255, 255, 0.3) 8px
              )`,
              backgroundSize: "10px 100%",
              display: "inline-block",
              minHeight: "20px"

            }}
            > </span>
            <div className="descriptions">
              <div className="trend">
                <div className="item">
                <img src={Orderpng4} alt="Order png" style={{width:'80%', height:'80%'}} />
                </div>
                <div className="item-desc">
                  <span >Current Trending</span>
                  <span >Paracetama</span>
                  <span>Instant Headache healing</span>
                </div>
              </div>
              <div className="trend">
                <div className="item">
                  <img src={Orderpng} alt="Order png" style={{width:'80%', height:'80%'}} />
                </div>
                <div className="item-desc">
                  <a class="btn btn-sm border-black action-btn mb-2" onClick={createDraftQuoteAndNavigateToDraft} role="button" style={{width: '160px'}}> Request For Quotation</a>
                  <span >Insta Orders</span>
                  <span> Reduce Paper Works</span> 
                </div>
                
              </div>
              
              
            </div>

          </div>

        </div>
      </div>  
      <Footer/>
    </div>  

      
   )
 }

export default Index;